import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import $api from '../api'
import { CreateFolderDTO, EditFolderDTO, GetFoldersListDto, PlaylistFolder } from './moodsSlice'

type BusinessId = string
interface State {
  businesses: Record<BusinessId, PlaylistFolder>
}

export const initialState: State = {
  businesses: {},
}
export const attemptCreateBusiness = createAsyncThunk<PlaylistFolder, CreateFolderDTO>(
  'businesses/business-create',
  async (payload) => {
    const response = await $api.post(`businesses/create`, payload)
    return response.data
  },
)

export const attemptGetBusinessesList = createAsyncThunk<PlaylistFolder[], GetFoldersListDto>(
  'businesses/list',
  async (payload) => {
    const response = await $api.post('businesses/admin/list', payload)
    return response.data
  },
)

export const attemptGetBusiness = createAsyncThunk<PlaylistFolder, string>(
  'businesses/get-business',
  async (id) => {
    const response = await $api.post(`businesses/get/${id}`)

    return response.data
  },
)

export const attemptEditBusiness = createAsyncThunk<void, EditFolderDTO>(
  'businesses/business-edit',
  async (payload) => {
    const response = await $api.post(`businesses/update/${payload._id}`, payload)
    return
  },
)

export const attemptDeleteBusiness = createAsyncThunk<
  PlaylistFolder['_id'],
  PlaylistFolder['_id']
>('businesses/business-delete', async (businessId) => {
  await $api.post(`businesses/delete/${businessId}`)
  return businessId
})

export const businessesReducer = createSlice({
  name: 'businesses',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(attemptCreateBusiness.fulfilled, (state, { payload }) => {
      // state.businesses[payload._id] = payload //don't need it as we are always fetching businesses when coming to the page
    })
    builder.addCase(attemptGetBusinessesList.fulfilled, (state, { payload }) => {
      payload.forEach((playlist) => {
        state.businesses[playlist._id] = playlist
      })
    })
    builder.addCase(attemptDeleteBusiness.fulfilled, (state, { payload: _id }) => {
      delete state.businesses[_id]
    })
  },
})

export const {} = businessesReducer.actions
export default businessesReducer.reducer
